export default {
  'dashboard.title': '대시보드',
  'dashboard.welcome': '안녕하세요, {{name}}님',
  'dashboard.subtitle': '오늘 처리가 필요한 항목입니다',

  'dashboard.menu.group.main': '메인',
  'dashboard.menu.group.products': '제품',
  'dashboard.menu.group.account': '계정',
  'dashboard.menu.welcomeBack': '다시 오신 것을 환영합니다',
  'dashboard.menu.backToHome': '홈으로 돌아가기',

  'dashboard.status.quotes': '대기 중인 견적',
  'dashboard.status.orders': '진행 중인 주문',
  'dashboard.status.messages': '읽지 않은 메시지',
  'dashboard.status.aiPreviews': '완료된 AI 프리뷰',
  'dashboard.status.payments': '대기 중인 결제',
  'dashboard.status.shipping': '배송 중',

  'dashboard.actionRequired': '필요한 조치',
  'dashboard.actionPriority.high': '높음',
  'dashboard.actionPriority.medium': '중간',
  'dashboard.actionPriority.low': '낮음',

  'dashboard.recentQuotes.title': '최근 견적',
  'dashboard.recentQuotes.quoteNumber': '견적 번호',
  'dashboard.recentQuotes.product': '제품',
  'dashboard.recentQuotes.finish': '마감',
  'dashboard.recentQuotes.quantity': '수량',
  'dashboard.recentQuotes.status': '상태',
  'dashboard.recentQuotes.amount': '금액',
  'dashboard.recentQuotes.view': '견적 보기',
  'dashboard.recentQuotes.viewAll': '전체 견적 보기',
  'dashboard.recentQuotes.requestNew': '새 견적 요청',
  'dashboard.recentQuotes.empty': '견적 내역이 없습니다. 포장 제품 견적을 요청해 보세요.',

  'dashboard.aiPreviews.title': 'AI 마감 프리뷰',
  'dashboard.aiPreviews.original': '원본',
  'dashboard.aiPreviews.generated': '생성됨',
  'dashboard.aiPreviews.product': '제품',
  'dashboard.aiPreviews.finish': '마감',
  'dashboard.aiPreviews.status': '상태',
  'dashboard.aiPreviews.view': '프리뷰 보기',
  'dashboard.aiPreviews.requestQuote': '견적 요청',
  'dashboard.aiPreviews.readyCta': '견적 요청 준비 완료',
  'dashboard.aiPreviews.empty': 'AI 프리뷰가 없습니다. 포장 디자인을 미리 확인해 보세요.',

  'dashboard.orders.title': '진행 중인 주문',
  'dashboard.orders.orderNumber': '주문 번호',
  'dashboard.orders.quoteRef': '견적 참조',
  'dashboard.orders.product': '제품',
  'dashboard.orders.payment': '결제',
  'dashboard.orders.production': '생산',
  'dashboard.orders.shipping': '배송',
  'dashboard.orders.total': '총액',
  'dashboard.orders.delivery': '예상 배송일',
  'dashboard.orders.view': '주문 보기',
  'dashboard.orders.empty': '진행 중인 주문이 없습니다. 견적 승인 후 주문이 여기에 표시됩니다.',

  'dashboard.payments.title': '결제 현황',
  'dashboard.payments.date': '날짜',
  'dashboard.payments.reference': '참조 번호',
  'dashboard.payments.amount': '금액',
  'dashboard.payments.status': '상태',
  'dashboard.payments.method': '결제 수단',
  'dashboard.payments.empty': '결제 내역이 없습니다.',

  'dashboard.shipping.title': '배송 현황',
  'dashboard.shipping.order': '주문 번호',
  'dashboard.shipping.carrier': '운송사',
  'dashboard.shipping.tracking': '운송장 번호',
  'dashboard.shipping.status': '상태',
  'dashboard.shipping.delivery': '예상 배송일',
  'dashboard.shipping.view': '상세 보기',
  'dashboard.shipping.empty': '배송 중인 물건이 없습니다.',

  'dashboard.messages.title': '메시지 센터',
  'dashboard.messages.related': '관련',
  'dashboard.messages.unread': '읽지 않음',
  'dashboard.messages.open': '메시지 열기',
  'dashboard.messages.empty': '메시지가 없습니다.',

  'dashboard.samples.title': '샘플 생산 요청',
  'dashboard.samples.requestNumber': '요청 번호',
  'dashboard.samples.product': '제품',
  'dashboard.samples.finish': '마감',
  'dashboard.samples.quantity': '수량',
  'dashboard.samples.status': '상태',
  'dashboard.samples.cost': '예상 비용',
  'dashboard.samples.view': '샘플 요청 보기',
  'dashboard.samples.empty': '샘플 요청이 없습니다.',

  'dashboard.files.title': '업로드한 파일',
  'dashboard.files.name': '파일',
  'dashboard.files.type': '유형',
  'dashboard.files.purpose': '용도',
  'dashboard.files.related': '관련',
  'dashboard.files.view': '보기',
  'dashboard.files.empty': '업로드한 파일이 없습니다.',

  'dashboard.savedProducts.title': '저장한 제품',
  'dashboard.savedProducts.category': '카테고리',
  'dashboard.savedProducts.sku': 'SKU',
  'dashboard.savedProducts.view': '제품 보기',
  'dashboard.savedProducts.quote': '견적 요청',
  'dashboard.savedProducts.preview': 'AI 프리뷰',
  'dashboard.savedProducts.empty': '저장한 제품이 없습니다. 제품을 둘러보고 관심 제품을 저장해 보세요.',

  'dashboard.company.title': '회사 프로필',
  'dashboard.company.completion': '{{percent}}% 완료',
  'dashboard.company.missing': '누락 항목:',
  'dashboard.company.completeButton': '회사 프로필 완성하기',

  'dashboard.market.title': '시장 설정',
  'dashboard.market.country': '국가',
  'dashboard.market.language': '언어',
  'dashboard.market.displayCurrency': '표시 통화',
  'dashboard.market.quoteBase': '견적 기준 통화',
  'dashboard.market.exchangeRate': '환율 기준일',
  'dashboard.market.change': '설정 변경',

  'dashboard.status.quoted': '견적 완료',
  'dashboard.status.submitted': '접수 완료',
  'dashboard.status.accepted': '승인',
  'dashboard.status.rejected': '거절',
  'dashboard.status.draft': '작성 중',
  'dashboard.status.expired': '만료',

  'dashboard.paymentStatus.pending': '대기 중',
  'dashboard.paymentStatus.completed': '완료',
  'dashboard.paymentStatus.failed': '실패',
  'dashboard.paymentStatus.refunded': '환불',
  'dashboard.paymentStatus.partial': '부분 결제',

  'dashboard.productionStatus.not_started': '시작 전',
  'dashboard.productionStatus.in_progress': '진행 중',
  'dashboard.productionStatus.completed': '완료',

  'dashboard.shippingStatus.not_shipped': '미배송',
  'dashboard.shippingStatus.packing': '포장 중',
  'dashboard.shippingStatus.shipped': '배송 중',
  'dashboard.shippingStatus.delivered': '배송 완료',

  'dashboard.shipmentStatus.pre_transit': '배송 준비 중',
  'dashboard.shipmentStatus.in_transit': '배송 중',
  'dashboard.shipmentStatus.out_for_delivery': '배달 출발',
  'dashboard.shipmentStatus.delivered': '배달 완료',
  'dashboard.shipmentStatus.exception': '배송 예외',

  'dashboard.sampleStatus.requested': '요청됨',
  'dashboard.sampleStatus.under_review': '검토 중',
  'dashboard.sampleStatus.quoted': '견적 완료',
  'dashboard.sampleStatus.in_production': '생산 중',
  'dashboard.sampleStatus.shipped': '발송됨',
  'dashboard.sampleStatus.completed': '완료',
  'dashboard.sampleStatus.cancelled': '취소',

  'dashboard.aiStatus.queued': '대기 중',
  'dashboard.aiStatus.processing': '처리 중',
  'dashboard.aiStatus.completed': '완료',
  'dashboard.aiStatus.failed': '실패',

  'dashboard.filePurpose.image_search': '이미지 검색',
  'dashboard.filePurpose.quote_reference': '견적 참조',
  'dashboard.filePurpose.ai_finish_source': 'AI 마감 소스',
  'dashboard.filePurpose.sample_reference': '샘플 참조',
  'dashboard.filePurpose.order_document': '주문 서류',

  'dashboard.seeAll': '전체 보기',
  'dashboard.noData': '—',

  // Company Profile Page
  'companyProfile.pageTitle': '회사 프로필',
  'companyProfile.subtitle': '견적, 주문, 배송 및 업무 소통을 위한 회사 정보를 관리하세요.',
  'companyProfile.section.companyInfo': '회사 정보',
  'companyProfile.section.contactInfo': '연락처 정보',
  'companyProfile.section.businessInfo': '사업자 정보',
  'companyProfile.section.accountStatus': '계정 상태',
  'companyProfile.field.companyName': '회사명',
  'companyProfile.field.country': '국가',
  'companyProfile.field.businessType': '사업 유형',
  'companyProfile.field.website': '웹사이트',
  'companyProfile.field.contactEmail': '연락 이메일',
  'companyProfile.field.contactPhone': '연락 전화',
  'companyProfile.field.taxId': '사업자등록번호 / VAT 번호',
  'companyProfile.field.companySize': '회사 규모',
  'companyProfile.field.status': '상태',
  'companyProfile.status.active': '활성',
  'companyProfile.status.inactive': '비활성',
  'companyProfile.status.suspended': '중지됨',
  'companyProfile.statusNotice': '회사 계정 상태 검토가 필요한 경우 고객 지원팀에 문의해 주세요.',
  'companyProfile.saveButton': '변경사항 저장',
  'companyProfile.saving': '저장 중...',
  'companyProfile.successMessage': '회사 프로필이 성공적으로 업데이트되었습니다.',
  'companyProfile.errorMessage': '회사 프로필 저장에 실패했습니다. 다시 시도해 주세요.',
  'companyProfile.validation.required': '필수 입력 항목입니다',
  'companyProfile.validation.email': '올바른 이메일 주소를 입력해 주세요',
  'companyProfile.validation.url': '올바른 URL을 입력해 주세요',
  'companyProfile.selectPlaceholder': '선택...',
  'companyProfile.createdAt': '생성일',
  'companyProfile.updatedAt': '최종 수정일',
};